module.exports = __webpack_public_path__ + "img/audio_play_background.c327665c.png";